/**
 * LivePerson script provided by Bish Labib <blabib@australiansuper.com> from AusSuper.
 * LivePerson contact is Sandeep Karuppuswamy <skaruppuswamy@liveperson.com>.
 *
 * Generated from LivePerson account/dashboard.
 * Ref: https://knowledge.liveperson.com/getting-started-add-the-liveperson-tag-to-your-website.html
 */

import Cta from 'core/components/Cta';
import { useAppContext } from 'core/hooks';
import React from 'react';
import RichText from 'core/components/RichText';
import { MODAL_ARIA_NAMES } from 'core/constants';

import * as S from '../LivePerson.style';
import { IFields } from '../LivePerson.sitecore';

const LPModalFormConfirm = ({
	fields,
	onConfirm,
}: {
	fields: IFields;
	onConfirm: (isAccepted: boolean) => void;
}) => {
	const { handleLivePersonModal } = useAppContext();

	return (
		<>
			<div>
				<div id={MODAL_ARIA_NAMES.DESCRIPTION}>
					<RichText content={fields?.invitationMessage?.value} />
				</div>
				<S.CtaContainer>
					<S.CtaContainerLeft>
						<Cta
							ctaStyle="primary"
							ctaType="button"
							buttonType="submit"
							data-target-id="live-person-submit-label"
							size="medium"
							onClick={() => {
								onConfirm(true);
								handleLivePersonModal(false);
							}}
						>
							{fields?.acceptLabel?.value}
						</Cta>
						<Cta
							ctaStyle="secondary"
							ctaType="button"
							onClick={() => {
								onConfirm(false);
								handleLivePersonModal(false);
							}}
							data-target-id="live-person-cancel-label"
							size="medium"
						>
							{fields?.rejectLabel?.value}
						</Cta>
					</S.CtaContainerLeft>
					<S.CtaContainerRight>
						<Cta
							ctaStyle="plain"
							ctaType="button"
							onClick={() => {
								handleLivePersonModal(false);
							}}
							data-target-id="live-person-cancel-label"
							size="medium"
						>
							{fields?.cancelButtonLabel?.value}
						</Cta>
					</S.CtaContainerRight>
				</S.CtaContainer>
			</div>
		</>
	);
};

export default LPModalFormConfirm;
